import { useQuery } from '@tanstack/react-query'
import supabase from 'sdk/api'

const getSalonsAllowedCountries = async () => {
    const { data, error } = await supabase
        .from('salons_allowed_countries')
        .select(`*`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetSalonsAllowedCountries() {
    return useQuery({
        queryKey: ['useGetSalonsAllowedCountries'],
        queryFn: () => getSalonsAllowedCountries(),
        staleTime: 0,
    })
}
